import { ICardEventAdmin, ICardEventAdminPost } from "../../models/component/ICardEventAdmin";
import http from "../http-common";

// Récupérer tous les événements
const getAllEvents = () => {
  return http.get<ICardEventAdmin[]>("/events");
};

// Récupérer un événement par son ID
const getEventById = (id: number, token: string) => {
  return http.get<ICardEventAdmin>(`/events/${id}`, { headers: { Authorization: "Bearer " + token } });
};

// Ajouter un nouvel événement avec des images
const addEvent = (data: ICardEventAdminPost, images: FileList, token: string) => {
  const formData = new FormData();
  formData.append('name', data.name);
  formData.append('description', data.description);
  formData.append('date', data.date);
  for (let i = 0; i < images.length; i++) {
    formData.append('images', images[i]);
  }
  const eventData = {
    name: formData.get('name'),
    description: formData.get('description'),
    date: formData.get('date')
  };
  const newEventBlob = new Blob([JSON.stringify(eventData)], { type: 'application/json' });

  // Ajouter newEvent en tant que RequestPart séparé
  formData.append('newEvent', newEventBlob);

  return http.post<ICardEventAdminPost>("/events", formData, {
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "multipart/form-data"
    }
  });
};

// Ajouter des images à un événement existant
const addImages = (id: number, images: File[], token: string) => {
  const formData = new FormData();
  images.forEach((image) => {
    formData.append("images", image);
  });

  return http.post<ICardEventAdmin>(`/events/${id}`, formData, {
    headers: {
      Authorization: "Bearer " + token,
      'Content-Type': 'multipart/form-data'
    }
  });
};

// Modification de la méthode post pour gérer les images
const post = (data: ICardEventAdminPost, token: string) => {
  return http.post<any>("/events", data, { headers: { Authorization: "Bearer " + token } });
};

// Modification de la méthode update pour gérer les images
const update = (id: number, data: ICardEventAdmin, token: string) => {
  return http.put<any>(`/events/${id}`, data, { headers: { Authorization: "Bearer " + token } });
};

// Supprimer un événement
const remove = (id: number, token: string) => {
  return http.delete<any>(`/events/${id}`, { headers: { Authorization: "Bearer " + token } });
};

// Récupérer une image par son ID
const getImageById = (imageId: number, token: string) => {
  return http.get<any>(`/events/images/${imageId}`, { headers: { Authorization: "Bearer " + token } });
};

// Supprimer une image par son ID
const deleteImage = (imageId: number, token: string) => {
  return http.delete<any>(`/events/images/${imageId}`, { headers: { Authorization: "Bearer " + token } });
};

const EventService = {
  getAllEvents,
  getEventById,
  addEvent,
  addImages,
  post,
  update,
  remove,
  getImageById,
  deleteImage,
};

export default EventService;
